import React from "react";
// Error Block page

// Default
import { Handle, Position } from "@xyflow/react";

// Mui
import Card from "@mui/material/Card";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Stack from "@mui/material/Stack";

const ErrorBlock = ({ data }: { data: any }) => {
  return (
    <Card
      sx={{
        width: "170px",
        borderRadius: "8px",
        boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.2)",
        overflow: "hidden",
        backgroundColor: "#FFFFFF",
      }}>
      {/* Header */}
      <Box
        sx={{
          textAlign: "center",
          padding: "5px",
          background: "linear-gradient(180deg, #FF7F7F 0%, #FF4D4D 100%)",
        }}>
        <Typography
          variant="body1"
          color="#FFFFFF"
          fontWeight={600}
          fontSize={"12px"}>
          {data.ruleName || "Exception Block"}
        </Typography>
      </Box>

      <Stack padding={"5px"} textAlign={"center"}>
        {data.attributes && data.attributes.length > 0 ? (
          data.attributes.map((attr: any, index: number) => (
            <Stack
              key={index}
              direction={"row"}
              justifyContent={"space-between"}
              alignItems={"center"}>
              <Typography variant="body2" fontSize={"9px"} fontWeight={600}>
                {attr.label}:
              </Typography>
              <Typography variant="body2" fontSize={"9px"}>
                {attr.value || "Not Set"}
              </Typography>
            </Stack>
          ))
        ) : (
          <Typography variant="body2" fontSize={"9px"}>
            No attributes configured
          </Typography>
        )}
      </Stack>

      {/* Handles */}
      <Handle type="target" position={Position.Left} style={styles.handle} />
      <Handle type="source" position={Position.Right} style={styles.handle} />
    </Card>
  );
};

const styles = {
  handle: {
    width: "10px",
    height: "10px",
    background: "#555",
  },
};

export default ErrorBlock;
